import Styled from './section_curriculo.module.css'
import * as CG from '../../../Components/Global'
import { useLandingContext } from '../../../Context'
import HTMLReactParser from 'html-react-parser'

const PageCurriculo = () => {
    const useLanding = useLandingContext()

    return (
        <main id="curriculo" className={Styled.content_curriculo}>
            <CG.H2>Currículo</CG.H2>
            <div className={Styled.container_about}>
                <img src={useLanding.websiteSettings.imgCurriculo.url} alt={useLanding.websiteSettings.imgCurriculo.name} />
                <p>{HTMLReactParser(useLanding.websiteSettings.textCurriculo.value)}</p>
            </div>
        </main>
    )
}

export default PageCurriculo